import { LinkField } from "@sitecore-jss/sitecore-jss-nextjs";
import { Field, Text } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import * as Flex from "@repo/ui/flex";
import { TYPOGRAPHY_LABEL3 } from "@/typography-constants";
import AnimatedCtaLink from "../../animated-cta-link/animated-cta-link";
import { isMobile } from "../../utils";
import styles from "./feature-carousel-header.module.css";

export interface FeatureCarouselHeaderProps {
  title: Field<string>;
  link?: LinkField;
}

const FeatureCarouselHeader = ({ title, link }: FeatureCarouselHeaderProps) => {
  const mobileView = isMobile();

  return (
    <Flex.Container
      justify="space-between"
      align="center"
      className={styles.carouselHeader}
    >
      <Text
        data-testid="header-title"
        field={title}
        className="typographyHeading1"
        tag="p"
      />
      {!mobileView && link?.value.href && (
        <AnimatedCtaLink
          className={clsx(TYPOGRAPHY_LABEL3)}
          link={{
            value: {
              text: link?.value.text,
              href: link?.value.href,
            },
          }}
        />
      )}
    </Flex.Container>
  );
};

export default FeatureCarouselHeader;
